import './readmore.scss';

export default (context: HTMLElement | Document = document) => {
  const containers: NodeListOf<HTMLElement> = context.querySelectorAll('.readmore-container');
  for (const container of containers) {
    const childElm: HTMLElement | null = container.querySelector('.readmore-overflown');
    const readmoreBtn = container.querySelector('.js-toggle-readmore') as HTMLElement | null;

    if (!readmoreBtn || !childElm) continue;

    readmoreBtn.addEventListener('click', (e) => {
      e.preventDefault();
      toggleState((e.target as HTMLElement).closest('a'), childElm);
      readmoreBtn.classList.toggle('more');
    });

    if (checkIfOverflown(childElm)) {
      container.classList.add('overflown', 'stop-max-height');
      readmoreBtn.classList.remove('d-none');
      readmoreBtn.style.removeProperty('display');
      childElm.classList.remove('no-overflow');
    } else {
      container.classList.remove('overflown', 'stop-max-height');
      readmoreBtn.classList.add('d-none');
      childElm.classList.add('no-overflow');
    }
  }
};

export const toggleState = (toggleBtn, readmoreText) => {
  const stateText =
    toggleBtn.innerText === toggleBtn.getAttribute('data-readless')
      ? toggleBtn.getAttribute('data-readmore')
      : toggleBtn.getAttribute('data-readless');
  readmoreText.classList.toggle('readmore-overflown');
  toggleBtn.innerHTML = stateText;
};

export const checkIfOverflown = (childElm: HTMLElement) => {
  // Content taller than the clamped container = needs read more
  return childElm.scrollHeight > childElm.clientHeight;
};
